var map = {
	"./1.png": 322,
	"./10.png": 232,
	"./11.png": 353,
	"./12.png": 386,
	"./2.png": 433,
	"./3.png": 216,
	"./4.png": 831,
	"./5.png": 342,
	"./6.png": 93,
	"./7.png": 180,
	"./8.png": 67,
	"./9.png": 242
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 812;